module.exports = __webpack_public_path__ + "img/Musa_acuminata.c1fc96c3.jpg";